import { observer } from "mobx-react-lite";
import { useReportBespoke } from "@iliotech/data-wire";
import s from "./ReportOrientationChanger.module.scss";
import classNames from "classnames";
export const ReportOrientationChanger = observer(() => {
  const store = useReportBespoke();
  const landscape = store.isLandscape();

  return (
    <div className={s.container}>
      <span className={s.title}>Orientation:</span>
      <div className={s.buttons}>
        <div
          className={classNames(s.button, !landscape && s.active)}
          onClick={() => store.changeOrientation()}
        >
          Portrait
        </div>
        <div
          className={classNames(s.button, landscape && s.active)}
          onClick={() => store.changeOrientation()}
        >
          Landscape
        </div>
      </div>
    </div>
  );
});
